import { type FC } from "react";

import { useQuery } from "@apollo/client/react";

import {
  DashboardProjectsDocumentsPageDocument,
  type PageFragment,
} from "@app_schema";

import { PageViewer } from "./page_viewer";

export const ProjectDocumentPageViewer: FC<{
  projectID: string;
  documentID: string;
  page: PageFragment;
}> = ({ projectID, documentID, page }) => {
  const { data } = useQuery(DashboardProjectsDocumentsPageDocument, {
    variables: { projectID, documentID, number: page.number },
  });

  return (
    <PageViewer page={page} html={data?.project.document.pages[0]?.html} />
  );
};
